import React from 'react';

const csrf = '';
export default React.createContext(csrf);
